<template>
    <div>
        <v-row>
            <v-col cols="12" xs="12" sm="8" style="text-align: justify;">
            {{$t('page.series.awards-option-title-1')}}
            </v-col>
        </v-row>
        <p></p>
      <v-data-table 
        :headers="headers" 
        :items="rows" 
        class="elevation-1 ma-0 tableCust2"
        :footer-props="{
          'items-per-page-text': $t('dataTable.rowsPerPageText'),
          'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
        }"
        :no-data-text="$t('dataTable.noDataText')"
        :headerProps="{
          'sort-by-text': $t('dataTable.sortByText')
        }"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on }">
              <v-btn-toggle dense>
                <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="newItem" :disabled="seriesSelected ? false : true">
                  <v-icon left dark>fa-plus</v-icon>
                  {{ $t('common.form.add') }}
                </v-btn> &nbsp;&nbsp;
                <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="importItem" :disabled="seriesSelected ? false : true">
                  <v-icon left dark>far fa-file-import</v-icon>
                  {{ $t('common.form.import') }}
                </v-btn>
              </v-btn-toggle>
              </template>
              <v-card class="borderDialog">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
  
                <v-card-text>
                  <v-form ref="formSC" class="pt-4 inputSeries">
                    <v-row>
                      <v-col sm="12" cols="12">
                        <v-select v-if="editorType == 'new' || editorType == 'edit'"
                          v-model="input.type"
                          :items="awardTypeArray"
                          item-text="text"
                          item-value="value"
                          ref="typeItems"
                          :label="$t('page.series.award-type')"
                          outlined dense
                          required
                          @keyup.enter="pressEnter"
                          @change="changeTypeAward"
                          :disabled="editorType == 'edit'"
                          :no-data-text="$t('common.no_data')"
                        >
                          <template slot="item" slot-scope="data">
                            <div class="text-left small-option">
                              {{data.item.text}} <br>
                              <span class="text-caption font-weight-bold" style="color: rgba(0, 0, 0, 0.6);">{{data.item.description}}</span>
                            </div>
                          </template>
                        </v-select>
                        <v-select v-if="(editorType == 'new' || editorType == 'edit') && input.type"
                          v-model="input.group"
                          :items="classGroup"
                          item-text="text"
                          item-value="value"
                          ref="groupItems"
                          :label="$t('page.series.class-group-name')"
                          outlined dense
                          required
                          return-object
                          @keyup.enter="pressEnter"
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                        <v-text-field v-if="(editorType == 'new' || editorType == 'edit') && input.type"
                          v-model="input.awardsPosition"
                          ref="inputawardsposition"
                          :label="$t('page.series.awards-position')"
                          required
                          outlined dense
                          :rules="[
                            (v) => $inputRules({value: v}, 'integer') || $t('page.series.awardsPosition-invalid')
                          ]"
                          @keyup.enter="pressEnter"
                        ></v-text-field>
                        <v-text-field v-if="(editorType == 'new' || editorType == 'edit') && input.type == 'recount'"
                          v-model="input.throwAways"
                          ref="inputthrowaway"
                          :label="$t('page.series.throw-away')"
                          required
                          outlined dense
                          :rules="[
                            (v) => $inputRules({value: v}, 'integer') || $t('page.series.throwAways-invalid')
                          ]"
                          @keyup.enter="pressEnter"
                        ></v-text-field>
                        <v-text-field v-if="(editorType == 'new' || editorType == 'edit') && input.type == 'recount'"
                          v-model="input.eventsToCount"
                          ref="inputeventstocount"
                          :label="$t('page.series.events-to-count')"
                          required
                          outlined dense
                          :rules="[
                            (v) => $inputRules({value: v}, 'integer') || $t('page.series.eventsToCount-invalid')
                          ]"
                          @keyup.enter="pressEnter"
                        ></v-text-field>
                        <v-text-field v-if="(editorType == 'new' || editorType == 'edit') && input.type == 'season'"
                          v-model="input.minEvents"
                          ref="minEvents"
                          :label="$t('page.series.min-events')"
                          required
                          outlined dense
                          :rules="[
                            (v) => $inputRules({value: v}, 'integer') || $t('page.series.minEvents-invalid')
                          ]"
                          @keyup.enter="pressEnter"
                        ></v-text-field>
                        <v-text-field v-if="(editorType == 'new' || editorType == 'edit') && input.type"
                          v-model="input.sortOrder"
                          ref="inputsortorder"
                          :label="$t('page.series.sort-order')"
                          required
                          outlined dense
                          :rules="[
                            (v) => $inputRules({value: v}, 'integer') || $t('page.series.sortOrder-invalid')
                          ]"
                          @keyup.enter="pressEnter"
                        ></v-text-field>
                        <v-select v-if="editorType == 'import'"
                          v-model="seriesModel"
                          :items="seriesItems"
                          ref="selectInput"
                          outlined dense
                          required
                          :rules="importRules"
                          @keyup.enter="importSeriesAwards"
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
  
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" small text @click="close">{{ $t('common.form.cancel') }}</v-btn>
                  <v-btn v-if="editorType == 'new'" color="blue darken-1" small text @click="create">{{ $t('common.form.create') }}</v-btn>
                  <v-btn v-if="editorType == 'edit'" color="blue darken-1" small text @click="save">{{ $t('common.form.update') }}</v-btn>
                  <v-btn v-if="editorType == 'import'" color="blue darken-1" @click="importSeriesAwards" small text>{{ $t('common.form.import') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:item.eventsToCount="{ item }">
          <span>{{item.awardType == 'recount' ? item.eventsToCount : "" }}</span>
        </template>
      </v-data-table>
        <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
        @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
        <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
    </div>
</template>
  
  
<script>
  import { apiCalls } from "@/mixins/apiCalls.js";
  import { mapState } from "vuex";
  import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
  import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
  
  export default {
    mixins: [apiCalls],
    properties: [],
    components: {
      SGSNotificationConfirm,
      SGSNotificationAlert
    },
    data() {
      return {
        classGroup: [],
        input: {
          class: null,
          group: null,
          groupItems: [],
          disableForSeries: null,
          eventsToCount: null,
          sortOrder: null,
          type: null,
          minEvents: null
        },
        dialogNotification: false,
        alertMessage: '',
        dialogAlert: false,
        inputName: '',
        seriesModel: null,
        seriesItems: [],
        dialog: false,
        importDialog: true,
        reopenEdition: false,
        rows: [],
        item: {
          id: "",
          name: 0
        },
        editorType: "new"
      };
    },
    computed: {
      ...mapState({
        seriesSelected: state => state.series.seriesSelected
      }),
      formTitle() {
        let title = ''
  
        if (this.editorType == "new") title = this.$t('page.series.add-awards')
        if (this.editorType == "edit") title = this.$t('page.series.edit-awards')
        if (this.editorType == "import") title = this.$t('page.series.import-awards')
        
        return title
      },
      importRules() {
        return [(v) => {
          return (v || '').toString().length > 0 || this.$t('page.series.series-required');
        }]
      },
      awardTypeArray() {
        return [
          { text: this.$t('page.series.season-scores'), value: 'season', description: this.$t('page.series.description-season-scores') },
          { text: this.$t('page.series.recount'), value: 'recount', description: this.$t('page.series.description-events') }
        ];
      },
      headers() {
        return [
          {
            text: this.$t("page.series.class-group-name"),
            value: "groupClassName"
          },
          {
            text: this.$t("page.series.awards-position"),
            value: "awardsPosition"
          },
          {
            text: this.$t("page.series.min-events"),
            value: "minimumEvents"
          },
          {
            text: this.$t("page.series.throw-away"),
            value: "throwAways"
          },
          {
            text: this.$t("page.series.events-to-count"),
            value: "eventsToCount"
          },
          {
            text: this.$t("page.series.sort-order"),
            value: "sortOrder"
          },
          {
            text: this.$t("common.table.actions"),
            value: "actions",
            sortable: false
          }
        ];
      }
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      init()
      {
        this.getRecords();
      },
      pressEnter(){ 
        if(this.editorType == "edit"){
          this.save()
        }else{
          this.create()
        }
      },
      async getRecords() {
        if(this.seriesSelected) {
          const response = await this.api(
            'get',
            `/api/v1/promoter/series/awards/${this.seriesSelected.id}`
          );
  
          this.rows = [];

          if(response.success === 1)
          {
            response.message.data.forEach((element, index) => {
              const row = { 
                id: element.id, 
                groupClassName: element.className || element.groupName || this.$t("page.series.overall"),
                groupClassId: element.classID || element.groupId,
                type: element.className ? 'class' : (element.groupName ? 'group' : undefined),
                awardsPosition: element.awardPositions,
                throwAways: element.throwAway,
                eventsToCount: element.eventsToCount,
                sortOrder: element.sortOrder,
                index: index,
                minimumEvents: element.minimumEvents,
                awardType: element.awardType, 
                actions: "actions"
              };
              
              this.rows.push(row);
            });
          }
          this.getSeries();
          this.getGroups();
        }
      },
      async getSeries() {
        if(this.seriesSelected) {
          const response = await this.getApi(
            "/api/v1/promoter/series"
          );
  
          if (response != undefined) {        
            for(var i = 0; i < response.length; i++){
              if(response[i].id == this.seriesSelected.id){
                continue;
              }
              this.seriesItems.push({
                text: response[i].seriesName,
                value: response[i].id
              });          
            }
            this.allSeries = response;
          }
        }
      },
      resetForm(){
          if(this.$refs.formSC) {
            this.$refs.formSC.reset();
          }
      },
      setForm(item){
          
          let group = null;
          if(item.groupClassName){
            if(item.groupClassId)
              group = {text: item.groupClassName, value: item.groupClassId};
            else 
              group = {text: item.groupClassName};
          } 
          this.input.group = group;
          this.input.awardsPosition = item.awardsPosition,
          this.input.eventsToCount = item.eventsToCount;
          this.input.sortOrder = (!item.sortOrder) ? 0 : item.sortOrder;
          this.input.throwAways = item.throwAways;
          this.input.id = item.id;
          this.input.index = item.index; 
          this.input.type = item.awardType; 
          this.input.minEvents = item.minimumEvents;
      },
      newItem() {
        this.input.type = null;
        this.resetForm();
        this.inputName = '';
        this.editorType = "new";
      },
      importItem(){
        if(this.$refs.formSC)
          this.$refs.formSC.resetValidation();
        this.editorType = "import";
        this.dialog =  true
      },
      editItem(item){
        //this.resetForm();
        this.setForm(item);
        this.editorType = "edit";
        this.dialog = true;
        this.inputName = item.name;
        this.item.id = item.id;
        if(this.$refs.formSC)
          this.$refs.formSC.resetValidation();
      },
      confirmDelete(item){
        this.dialogNotification = true
        this.item = item
      },
      async deleteItem() 
      {
        const response = await this.api("DELETE",`/api/v1/promoter/series/awards/${this.item.id}`);    

        if(response != undefined){
          if(!response.success) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.error) && response.error.length > 0) {
                this.alertMessage = this.$t('common.request.'+response.error[0]);
            } else if(typeof response.error == 'string') {
                this.alertMessage = this.$t('common.request.'+response.error)
            } else if(Array.isArray(response.message) && response.message.length > 0) {
                this.alertMessage = this.$t('common.request.'+response.message[0]);
            } else if(typeof response.message == 'string') {
                this.alertMessage = this.$t('common.request.'+response.message)
            }
            this.dialog = false;
            this.dialogAlert = true;
            return;
          }
          this.getRecords();
          this.close();
        }  else {
          this.alertMessage = this.$t('page.series.error_general');
          this.dialog = false;
          this.dialogAlert = true;
        }
      },
      close() {
        this.dialog = false;
        this.dialogNotification = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      async create(){
        if(this.$refs.formSC.validate()) {
  
          let data = {};
          data.seriesId = this.seriesSelected.id;
          let header = null;
          const find = this.classGroup.find((item) => {
              if(item.header) header = item.header;
              return (item.value && this.input.group && (item.value == this.input.group.value)) && (this.input.group && (item.text == this.input.group.text));
          });
          if(this.input.group && (!find || !find.value)) {//isOverall
              data.isOverall = 1;
              data.classId = null;
              data.groupId = null;
          } else if(header == this.$t("page.series.groups")) {
              data.groupId = this.input.group ? this.input.group.value : null;
          } else if(header == this.$t("page.series.classes")) {
              data.classId = this.input.group ? this.input.group.value : null;
          }
          data.awardPosition = this.input.awardsPosition;
          data.throwAway = this.input.throwAways;
          data.eventsToCount = this.input.eventsToCount;
          data.sortOrder = this.input.sortOrder;
          data.awardType = this.input.type;
          data.minimumEvents = this.input.minEvents;
          const response = await this.api("POST", "/api/v1/promoter/series/awards", data);

          if (response != undefined) {
            if(!response.success) {
              this.alertMessage = this.$t('page.series.error_general');
              if(Array.isArray(response.error) && response.error.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.error[0]);
              } else if(typeof response.error == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.error)
              } else if(Array.isArray(response.message) && response.message.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.message[0]);
              } else if(typeof response.message == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.message)
              }
              this.dialog = false;
              this.dialogAlert = true;
              this.reopenEdition = true;
              return;
            }

            this.getRecords();
            this.close();
          } else {
            this.alertMessage = this.$t('page.series.error_general');
            this.dialog = false;
            this.dialogAlert = true;
            this.reopenEdition = true;
          }
        }
      },
      async importSeriesAwards(){
        
          if(!this.$refs.formSC.validate()) {
            if(this.seriesModel == null || this.seriesModel == ''){
              this.$refs.selectInput.focus();
              return false;
            }
            return;
          }
          this.dialog = false
          let data = {
            seriesId: this.seriesSelected.id,
            targetSeriesId: this.seriesModel
          }

          const response = await this.api("POST", "/api/v1/promoter/series/awards/import", data);

          if (response != undefined) {
            if(!response.success) {
              this.alertMessage = this.$t('page.series.error_general');
              if(Array.isArray(response.error) && response.error.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.error[0]);
              } else if(typeof response.error == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.error)
              } else if(Array.isArray(response.message) && response.message.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.message[0]);
              } else if(typeof response.message == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.message)
              }
              this.dialog = false;
              this.dialogAlert = true;
              this.reopenEdition = true;
              return;
            }

            this.getRecords();
            this.close();
          } else {
            this.alertMessage = this.$t('page.series.error_general');
            this.dialog = false;
            this.dialogAlert = true;
            this.reopenEdition = true;
          }
      },
      async save() {
  
        if(this.$refs.formSC.validate()) {
          
          let data = {};
          data.id = this.input.id;
          let header = null;
          const find = this.classGroup.find((item) => {
              if(item.header) header = item.header;
              return item.value == this.input.group.value && item.text == this.input.group.text;
          });
          if(this.input.group && (!find || !find.value)) {//isOverall
              data.isOverall = 1;
              data.fkSeriesClassId = null;
              data.fkSeriesGroupId = null;
          } else if(header == this.$t("page.series.groups")) {
              data.fkSeriesGroupId = this.input.group.value;
              data.fkSeriesClassId = null;
              data.isOverall = 0;
          } else if(header == this.$t("page.series.classes")) {
              data.fkSeriesClassId = this.input.group.value;
              data.fkSeriesGroupId = null;
              data.isOverall = 0;
          }
          data.awardPositions = this.input.awardsPosition;
          data.throwAway = this.input.throwAways;
          data.eventsToCount = this.input.eventsToCount;
          data.sortOrder = this.input.sortOrder;
          data.awardType = this.input.type;
          data.minimumEvents = this.input.minEvents;
          data.seriesId = this.seriesSelected.id;
          
          const response = await this.api("PUT", "/api/v1/promoter/series/awards", data);
          
          if (response != undefined) {
            if(!response.success) {
              this.alertMessage = this.$t('page.series.error_general');
              if(Array.isArray(response.error) && response.error.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.error[0]);
              } else if(typeof response.error == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.error)
              } else if(Array.isArray(response.message) && response.message.length > 0) {
                  this.alertMessage = this.$t('common.request.'+response.message[0]);
              } else if(typeof response.message == 'string') {
                  this.alertMessage = this.$t('common.request.'+response.message)
              }
              this.dialog = false;
              this.dialogAlert = true;
              this.reopenEdition = true;
              return;
            }

            this.getRecords();
            this.close();
          } else {
            this.alertMessage = this.$t('page.series.error_general');
            this.dialog = false;
            this.dialogAlert = true;
            this.reopenEdition = true;
          }
        }
      },
      closeAlert(){
        this.dialogAlert=false;
        if(this.reopenEdition){
          this.dialog = true;
        }
      },
      async getGroups() {
        if(this.seriesSelected) {
            let responseClass = await this.api("get", `/api/v1/promoter/series/${this.seriesSelected.id}/class`);
            let responseGroup = await this.api("get", `/api/v1/promoter/series/group/${this.seriesSelected.id}`);
            responseClass = responseClass.message.data
            responseGroup = responseGroup.message.data
      
            this.classSeries = responseClass;
            this.classGroup = [];

            this.classGroup.push({ text: this.$t("page.series.overall") });
            this.classGroup.push({ header: this.$t("page.series.groups") });
            for (var j = 0; j < responseGroup.length; j++) {
                const element = {
                    text: `${responseGroup[j].groupName}`,
                    value: responseGroup[j].id
                };
                this.classGroup.push(element);
            }
        
            this.classGroup.push({ header: this.$t("page.series.classes") });
            for (var i = 0; i < responseClass.length; i++) {
                const element = {
                    text: `${responseClass[i].className}`,
                    value: responseClass[i].id
                };
                this.classGroup.push(element);
            }
        }
      },
      changeTypeAward() {
        this.input.class = null;
        this.input.group = null;
        this.input.disableForSeries = null;
        this.input.eventsToCount = this.input.type == 'season' ? null : 0;
        this.input.sortOrder = null;
        this.input.minEvents = null;
        if(this.$refs.formSC) this.$refs.formSC.resetValidation();
      }
    }
  };
  </script>

  <style scoped>
  .v-application .headline {
    font-size: 24px !important;
  }
  .v-dialog > .v-card > .v-card__text {
      padding: 0 40px 20px;
  }
  .v-card__actions .v-btn {
      background-color: var(--v-primary-darken2) !important;
      color: white !important;
  }
  .small-option {
    max-width: 450px;
  }
.v-text-field.v-text-field--enclosed {
    padding-top: 12px;
    margin-top: 4px;
}
  </style>
  